import { c as _c } from "react/compiler-runtime";
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useFunctionResult } from 'record-it-components/hooks/useFunctionResult/useFunctionResult';
import { EntityName } from 'record-it-time-common/EntityName';
import { ArrayUtils } from 'record-it-utils/utils/ArrayUtils/ArrayUtils';
import { useEntityChangedListener } from '../useEntityChangedListener/useEntityChangedListener';
import { useEntityRepository } from '../useEntityRepository';
export function useTimeTrackingActivityPathName(timeTrackingActivityId) {
  const $ = _c(10);
  const repository = useEntityRepository(EntityName.TimeTrackingActivity);
  const {
    t
  } = useTranslation();
  let t0;
  if ($[0] !== repository) {
    t0 = idParam => idParam ? repository.getPath(idParam) : null;
    $[0] = repository;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const wrappedFunction = t0;
  let t1;
  if ($[2] !== timeTrackingActivityId) {
    t1 = [timeTrackingActivityId];
    $[2] = timeTrackingActivityId;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1 || $[5] !== wrappedFunction) {
    t2 = {
      func: wrappedFunction,
      funcArgs: t1,
      resultsAreEqual: _temp
    };
    $[4] = t1;
    $[5] = wrappedFunction;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const {
    result: path,
    update
  } = useFunctionResult(t2);
  useEntityChangedListener(EntityName.TimeTrackingActivity, update);
  let t3;
  if ($[7] !== path || $[8] !== t) {
    t3 = path ? path.map(a_0 => {
      if (!a_0) {
        return t("hooks.entity.timeTrackingActivity.unknownActivity");
      }
      return a_0.name;
    }).join(" - ") : null;
    $[7] = path;
    $[8] = t;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}
function _temp(a, b) {
  return a != null && b != null && ArrayUtils.areShallowEqual(a, b);
}